import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';
import * as generalActions from '../../modules/general';
import * as donationActions from './store/donationActions';
import { bindActionCreators } from 'redux';
import { Button, Modal, Loader, Dimmer } from 'semantic-ui-react';
import { Record } from '../../modules/bin/utility';
import { grecaptcha } from '../../helpers/grecaptcha';
import { I18n } from 'react-redux-i18n';
import RefundModal from './RefundModal';
import DeleteModal from './DeleteModal';

class RefundWindow extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.refundConfirmation && !prevProps.refundConfirmation && this.props.refundRecord) {
      this.props.getRelatedRecord(this.props.refundRecord.id);
    }
  }

  onRefundClick = () => {
    const tokenCallback = (token) =>
      this.props.refundDonation(this.props.refundRecord.id, token);
    grecaptcha(tokenCallback, "DonationUpdate");
  };

  onDeleteClick = () => {
    this.props.deleteOfflineDonation(this.props.refundRecord.id);
  };

  onRefundConfirmClose = () => {
    this.props.closeRefundConfirmation();
  };

  clearMessages = () => {
    this.props.clearRecordMessages('saveRecord');
  };

  getPlacehubWarning() {
    const relatedData = get(this.props.relatedRecord, 'data.data');
    const fundraiser = get(relatedData, 'fundraiser');
    const eventAmbassadorCharge = get(relatedData, 'eventAmbassadorCharge');

    const isAmbassador = get(fundraiser, 'isAmbassador');
    const isApplicant = !isAmbassador && get(fundraiser, 'isAmbassadorApplicant');
    const hasFundraisingGuarantee = get(eventAmbassadorCharge, 'eventAmbassadorId');

    return isAmbassador || isApplicant || hasFundraisingGuarantee;
  }

  renderContent() {
    const email = get(this.props.refundRecord, 'donor.email');
    const firstName = get(this.props.refundRecord, 'donor.firstName');
    const lastName = get(this.props.refundRecord, 'donor.lastName');
    const amount = get(this.props.refundRecord, 'amount');
    const currency = get(this.props.refundRecord, 'currency');
    const receiptNumber = get(this.props.refundRecord, 'receiptNumber');
    const alreadyRefunded = get(this.props.refundRecord, 'financials.refunded');
    const isOffline = get(this.props.refundRecord, 'type') === 'offline';
    const isPledge = get(this.props.refundRecord, 'type') === 'pledge';
    const isOnline = get(this.props.refundRecord, 'type') === 'online';
    const isRefunding = Record.isRecordLoading(this.props.saveRecord);
    const isLoadingRelated = Record.isRecordLoading(this.props.relatedRecord);
    const showPlacehubWarning = this.getPlacehubWarning();

    if (alreadyRefunded) {
      const errorMessage = isOnline
        ? I18n.t('donation.refund-window.already-refunded.online-error', { receiptNumber })
        : I18n.t('donation.refund-window.already-refunded.offline-error', { receiptNumber });

      return (
        <Modal.Content>
          {errorMessage}
          <div
            className="button-wrapper align-right"
            style={{ marginTop: '10px' }}
          >
            <Button primary onClick={this.onRefundConfirmClose}>
              {I18n.t('donation.refund-window.ok')}
            </Button>
          </div>
        </Modal.Content>
      );
    }

    const commonProps = {
      amount,
      currency,
      email,
      firstName,
      lastName,
      receiptNumber,
      isLoadingRelated,
      showPlacehubWarning,
      onClose: this.onRefundConfirmClose
    };

    if (isOffline || isPledge) {
      return (
        <DeleteModal
          {...commonProps}
          isOffline={isOffline}
          isRefunding={isRefunding}
          onConfirm={this.onDeleteClick}
        />
      );
    }

    return (
      <RefundModal
        {...commonProps}
        email={email}
        isRefunding={isRefunding}
        onConfirm={this.onRefundClick}
      />
    );
  }

  render() {
    const isOffline = get(this.props.refundRecord, 'type') === 'offline';
    const isPledge = get(this.props.refundRecord, 'type') === 'pledge';

    const isRefunded = this.props.isRefunded;
    if (isRefunded) {
      this.props.generalActions.clearListsReadyState();
      this.props.clearIsRefunded();
    }

    const isDeleted = this.props.isDeleted;
    if (isDeleted && window) {
      this.props.generalActions.clearListsReadyState();
      this.props.clearIsDeleted();
    }

    const headerContent = isOffline || isPledge
      ? I18n.t('donation.refund-window.headers.confirmation-required')
      : I18n.t('donation.refund-window.headers.refund-confirmation');

    return (
      <Modal
        className="wizard"
        size="tiny"
        dimmer="inverted"
        closeIcon
        open={this.props.refundConfirmation}
        onClose={this.onRefundConfirmClose}
      >
        <Modal.Header>
          <h3>{headerContent}</h3>
        </Modal.Header>

        {this.renderContent()}
      </Modal>
    );
  }
}

const mapState = ({ donation, session, account }) => {
  return {
    saveRecord: donation.saveRecord,
    refundRecord: donation.refundDonation,
    isRefunded: donation.isRefunded,
    isDeleted: donation.isDeleted,
    refundConfirmation: donation.refundConfirmation,
    relatedRecord: donation.relatedRecord
  };
};

const mapDispatch = (dispatch) => {
  return {
    ...bindActionCreators(donationActions, dispatch),
    generalActions: bindActionCreators(generalActions, dispatch)
  };
};

const RefundWindowContainer = connect(mapState, mapDispatch)(RefundWindow);
export default RefundWindowContainer;
